import { useTranslation } from "react-i18next";
import { MediaGallery, SectionHeading, ValidationMessages } from "../../../components";

export const Review = () => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeading
        title={t("upload.review.title")}
        subtitle={t("upload.review.subtitle")}
      />
      <ValidationMessages />
      <MediaGallery />
    </>
  )
}